import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ab715b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-content contents" }
const _hoisted_2 = {
  class: "row",
  "data-v-4912753c": ""
}
const _hoisted_3 = {
  class: "col-md-3 pb-2",
  "data-v-4912753c": ""
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = { class: "tab-content pt-2" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xl-12" }
const _hoisted_12 = {
  class: "card shadow-0 mb-1",
  style: {"border":"none"},
  "data-filter-tags": "oliver kopyov"
}
const _hoisted_13 = { class: "p-3" }
const _hoisted_14 = { class: "row variationLine pb-3 mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "バリエーション名", -1))
const _hoisted_16 = { class: "col-md-5 contCnt" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "バリエーション管理番号", -1))
const _hoisted_19 = { class: "col-md-2 contCnt" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "col-md-3 contTitle text-right" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6 contCnt" }
const _hoisted_26 = {
  key: 0,
  class: "row"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "サイズ", -1))
const _hoisted_28 = { class: "col-md-10 contCnt" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 1,
  class: "row"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "サイズ", -1))
const _hoisted_32 = { class: "col-md-10 contCnt" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = {
  key: 2,
  class: "row"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "サイズ", -1))
const _hoisted_36 = { class: "col-md-10 contCnt" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = {
  key: 3,
  class: "row"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "時間", -1))
const _hoisted_40 = { class: "col-md-10 contCnt" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-xl-6 contCnt" }
const _hoisted_43 = { class: "input-group" }
const _hoisted_44 = ["onUpdate:modelValue", "onChange"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "～")
], -1))
const _hoisted_46 = ["onUpdate:modelValue", "onChange"]
const _hoisted_47 = { class: "col-xl-6 contCnt" }
const _hoisted_48 = { class: "input-group" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "時間")
], -1))
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "分")
], -1))
const _hoisted_53 = {
  key: 4,
  class: "row"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "仕様選択", -1))
const _hoisted_55 = { class: "col-md-10 contTitle" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "項目選択", -1))
const _hoisted_58 = { class: "col-md-10 contTitle" }
const _hoisted_59 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "期間", -1))
const _hoisted_62 = { class: "col col-sm-2 contCnt" }
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { class: "col-auto contCnt" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "金額(税別)", -1))
const _hoisted_67 = { class: "col-sm-6 contTitle input-group" }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "円")
], -1))
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "金額種別", -1))
const _hoisted_72 = { class: "col-md-10 contCnt" }
const _hoisted_73 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_74 = ["id", "onUpdate:modelValue"]
const _hoisted_75 = ["for"]
const _hoisted_76 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_77 = ["id", "onUpdate:modelValue"]
const _hoisted_78 = ["for"]
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "販売マージン", -1))
const _hoisted_81 = { class: "col-md-10 contCnt" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-md-5 contTitle input-group" }
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "%")
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "仕入マージン", -1))
const _hoisted_87 = { class: "col-md-5 contTitle input-group" }
const _hoisted_88 = ["onUpdate:modelValue"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "%")
], -1))
const _hoisted_90 = { class: "col-md-6 contCnt" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "備考", -1))
const _hoisted_93 = { class: "col-md-10 contTitle" }
const _hoisted_94 = ["onUpdate:modelValue"]
const _hoisted_95 = ["onUpdate:modelValue"]
const _hoisted_96 = ["onUpdate:modelValue"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_98 = { class: "text-success fw-500" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_102 = { class: "text-success fw-500" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_condition = _resolveComponent("Mo_condition")!
  const _component_Or_selectItem = _resolveComponent("Or_selectItem")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-sm btn-info waves-effect waves-themed mr-1",
          "data-v-4912753c": "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addVariation()))
        }, " バリエーション追加 ", 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations, (variation, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: index
        }, [
          (index == _ctx.activeTab)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "nav-link active",
                "data-toggle": "tab",
                href: '#js_change_pill_justified-variation-' + index,
                onClick: ($event: any) => (_ctx.setActiveTab(index))
              }, _toDisplayString(variation.c_variation_name), 9, _hoisted_6))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "nav-link",
                "data-toggle": "tab",
                href: '#js_change_pill_justified-variation-' + index,
                onClick: ($event: any) => (_ctx.setActiveTab(index))
              }, _toDisplayString(variation.c_variation_name), 9, _hoisted_7))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations, (variation, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(
            index == _ctx.activeTab ? 'tab-pane fade active show' : 'tab-pane fade'
          ),
          id: 'js_change_pill_justified-variation-' + index,
          role: "tabpanel"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtClientNm",
                        class: "form-control form-control-sm",
                        maxlength: "200",
                        "onUpdate:modelValue": ($event: any) => ((variation.c_variation_name) = $event)
                      }, null, 8, _hoisted_17), [
                        [_vModelText, variation.c_variation_name]
                      ])
                    ]),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtClientNm",
                        class: "form-control form-control-sm",
                        maxlength: "200",
                        "onUpdate:modelValue": ($event: any) => ((variation.c_variation_manag_name) = $event)
                      }, null, 8, _hoisted_20), [
                        [_vModelText, variation.c_variation_manag_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger waves-effect waves-themed",
                        style: {"margin-left":"15px"},
                        onClick: ($event: any) => (_ctx.delConf(index))
                      }, " 削除 ", 8, _hoisted_22),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-info waves-effect waves-themed",
                        style: {"margin-left":"15px"},
                        onClick: ($event: any) => (_ctx.cpyVariation(index))
                      }, " コピー ", 8, _hoisted_23)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.c_item_type == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                placeholder: "（B1・B0・その他）　　面（枚）　",
                                style: {"height":"53px"},
                                "onUpdate:modelValue": ($event: any) => ((variation.c_variation_size) = $event)
                              }, null, 8, _hoisted_29), [
                                [_vModelText, variation.c_variation_size]
                              ])
                            ])
                          ]))
                        : (_ctx.c_item_type == 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("div", _hoisted_32, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-control",
                                  placeholder: "　　inch　（H　　　m　×　W　　　ｍ　　　㎡）　　　面　",
                                  style: {"height":"53px"},
                                  "onUpdate:modelValue": ($event: any) => ((variation.c_variation_size) = $event)
                                }, null, 8, _hoisted_33), [
                                  [_vModelText, variation.c_variation_size]
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-control",
                                  placeholder: "H　　　m　×　W　　　ｍ　　　㎡　　　面",
                                  style: {"height":"53px"},
                                  "onUpdate:modelValue": ($event: any) => ((variation.c_variation_size) = $event)
                                }, null, 8, _hoisted_37), [
                                  [_vModelText, variation.c_variation_size]
                                ])
                              ])
                            ])),
                      (_ctx.c_item_type == 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "time",
                                      name: "txtClientNm",
                                      class: "form-control form-control-sm",
                                      maxlength: "200",
                                      "onUpdate:modelValue": ($event: any) => ((variation.c_variation_time_start) = $event),
                                      onChange: ($event: any) => (_ctx.timeChange(index))
                                    }, null, 40, _hoisted_44), [
                                      [_vModelText, variation.c_variation_time_start]
                                    ]),
                                    _hoisted_45,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "time",
                                      name: "txtClientNm",
                                      class: "form-control form-control-sm",
                                      maxlength: "200",
                                      "onUpdate:modelValue": ($event: any) => ((variation.c_variation_time_end) = $event),
                                      onChange: ($event: any) => (_ctx.timeChange(index))
                                    }, null, 40, _hoisted_46), [
                                      [_vModelText, variation.c_variation_time_end]
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      name: "txtClientNm",
                                      class: "form-control form-control-sm",
                                      maxlength: "200",
                                      "onUpdate:modelValue": ($event: any) => ((variation.hour) = $event)
                                    }, null, 8, _hoisted_49), [
                                      [_vModelText, variation.hour]
                                    ]),
                                    _hoisted_50,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      name: "txtClientNm",
                                      class: "form-control form-control-sm",
                                      maxlength: "200",
                                      "onUpdate:modelValue": ($event: any) => ((variation.min) = $event)
                                    }, null, 8, _hoisted_51), [
                                      [_vModelText, variation.min]
                                    ]),
                                    _hoisted_52
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.c_item_type != 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_vSelect, {
                                class: "",
                                style: {},
                                options: _ctx.optionsOp9,
                                multiple: "",
                                modelValue: variation.cnvSpecification,
                                "onUpdate:modelValue": ($event: any) => ((variation.cnvSpecification) = $event),
                                reduce: (label) => label.code
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "reduce"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_vSelect, {
                            class: "",
                            style: {},
                            options: _ctx.opSupplyType,
                            modelValue: variation.cnvType[0],
                            "onUpdate:modelValue": ($event: any) => ((variation.cnvType[0]) = $event),
                            reduce: (label) => label.code
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "reduce"]),
                          (_ctx.errors?.path === 'supplyType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.errors.message), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtClientNm",
                            class: "form-control form-control-sm text-right",
                            maxlength: "200",
                            "onUpdate:modelValue": ($event: any) => ((variation.c_variation_term) = $event)
                          }, null, 8, _hoisted_63), [
                            [_vModelText, variation.c_variation_term]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_vSelect, {
                            class: "",
                            style: {},
                            options: _ctx.optionsOp10,
                            modelValue: variation.c_variation_term_type,
                            "onUpdate:modelValue": ($event: any) => ((variation.c_variation_term_type) = $event),
                            reduce: (label) => label.code
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "reduce"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "txtClientNm",
                            class: "form-control form-control-sm text-right",
                            maxlength: "200",
                            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kanmaDel($event))),
                            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.kanmaIns($event))),
                            "onUpdate:modelValue": ($event: any) => ((variation.cnvPrice) = $event)
                          }, null, 40, _hoisted_68), [
                            [_vModelText, variation.cnvPrice]
                          ]),
                          _hoisted_69
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "custom-control-input",
                              id: 
                                'kingakusyurui1Gurosu1_' +
                                variation.c_variation_id
                              ,
                              "onUpdate:modelValue": ($event: any) => ((variation.c_variation_price_type) = $event),
                              value: "1"
                            }, null, 8, _hoisted_74), [
                              [_vModelRadio, variation.c_variation_price_type]
                            ]),
                            _createElementVNode("label", {
                              class: "custom-control-label",
                              for: 
                                'kingakusyurui1Gurosu1_' +
                                variation.c_variation_id
                              
                            }, "グロス", 8, _hoisted_75)
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "custom-control-input",
                              id: 
                                'kingakusyurui1Gurosu2_' +
                                variation.c_variation_id
                              ,
                              "onUpdate:modelValue": ($event: any) => ((variation.c_variation_price_type) = $event),
                              value: "2"
                            }, null, 8, _hoisted_77), [
                              [_vModelRadio, variation.c_variation_price_type]
                            ]),
                            _createElementVNode("label", {
                              class: "custom-control-label",
                              for: 
                                'kingakusyurui1Gurosu2_' +
                                variation.c_variation_id
                              
                            }, "ネット", 8, _hoisted_78)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "any",
                                min: "0",
                                max: "100",
                                name: "txtClientNm",
                                class: "form-control form-control-sm text-right",
                                maxlength: "200",
                                "onUpdate:modelValue": ($event: any) => ((variation.c_variation_margin_sales) = $event)
                              }, null, 8, _hoisted_84), [
                                [_vModelText, variation.c_variation_margin_sales]
                              ]),
                              _hoisted_85
                            ]),
                            _hoisted_86,
                            _createElementVNode("div", _hoisted_87, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "any",
                                min: "0",
                                max: "100",
                                name: "txtClientNm",
                                class: "form-control form-control-sm text-right",
                                maxlength: "200",
                                "onUpdate:modelValue": ($event: any) => ((variation.c_variation_margin_supply) = $event)
                              }, null, 8, _hoisted_88), [
                                [_vModelText, variation.c_variation_margin_supply]
                              ]),
                              _hoisted_89
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _hoisted_92,
                        _createElementVNode("div", _hoisted_93, [
                          (_ctx.c_item_type == 2)
                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 0,
                                class: "form-control jokenTxtArea2",
                                placeholder: "以下、事例。\nスタート日（1日または16日）、電気料金込み、保守管理料金込み、事前クライアント及びデザイン審査あり、決定優先。\n完全データ入稿（制作期間として、入稿から提出開始まで約4週間を要します。）\nなどなど",
                                "onUpdate:modelValue": ($event: any) => ((variation.c_variation_remarks) = $event)
                              }, null, 8, _hoisted_94)), [
                                [_vModelText, variation.c_variation_remarks]
                              ])
                            : (_ctx.c_item_type == 4)
                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  class: "form-control jokenTxtArea4",
                                  placeholder: "以下、事例。\nスタート日（1日または16日）、電気料金込み、保守管理料金込み、事前クライアント及びデザイン審査あり、決定優先。\n完全データ入稿（制作期間として、入稿から提出開始まで約4週間を要します。）\nなどなど",
                                  "onUpdate:modelValue": ($event: any) => ((variation.c_variation_remarks) = $event)
                                }, null, 8, _hoisted_95)), [
                                  [_vModelText, variation.c_variation_remarks]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 2,
                                  class: "form-control jokenTxtArea",
                                  placeholder: "以下、事例。\nスタート日（1日または16日）、電気料金込み、保守管理料金込み、事前クライアント及びデザイン審査あり、決定優先。\n完全データ入稿（制作期間として、入稿から提出開始まで約4週間を要します。）\nなどなど",
                                  "onUpdate:modelValue": ($event: any) => ((variation.c_variation_remarks) = $event)
                                }, null, 8, _hoisted_96)), [
                                  [_vModelText, variation.c_variation_remarks]
                                ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(_component_Mo_condition, {
                    ref_for: true,
                    ref: "Mo_condition",
                    conditions: variation.conditions,
                    "onUpdate:conditions": ($event: any) => ((variation.conditions) = $event),
                    c_variation_id: variation.c_variation_id,
                    "onUpdate:c_variation_id": ($event: any) => ((variation.c_variation_id) = $event),
                    items4Supplyers: _ctx.items4Supplyers,
                    "onUpdate:items4Supplyers": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.items4Supplyers) = $event)),
                    itemName: _ctx.itemName,
                    "onUpdate:itemName": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemName) = $event)),
                    variationName: variation.c_variation_name,
                    "onUpdate:variationName": ($event: any) => ((variation.c_variation_name) = $event),
                    onItemSelectCondi: _cache[5] || (_cache[5] = ($event: any) => (_ctx.itemSelectCondi($event))),
                    onGet: _ctx.get,
                    onUpd: _ctx.upd
                  }, null, 8, ["conditions", "onUpdate:conditions", "c_variation_id", "onUpdate:c_variation_id", "items4Supplyers", "itemName", "variationName", "onUpdate:variationName", "onGet", "onUpd"])
                ])
              ])
            ])
          ])
        ], 10, _hoisted_9))
      }), 128))
    ]),
    _createVNode(_component_Or_selectItem, {
      ref: "comp_itemSelect4condition",
      evDatas: _ctx.evDatas4item,
      "onUpdate:evDatas": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.evDatas4item) = $event))
    }, null, 8, ["evDatas"]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_97,
        _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_99
      ]),
      footer: _withCtx(() => [
        _hoisted_100
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_success_no_get" }, {
      title: _withCtx(() => [
        _hoisted_101,
        _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_103
      ]),
      footer: _withCtx(() => [
        _hoisted_104
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_105,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_106
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.delVariation())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}